if(!customElements.get('store-reviews')) {
    class StoreReviews extends HTMLElement {
        constructor() {
            super();
            this.maxChars = 285;
        }
        connectedCallback() {
            this.selectors = {
                reviewsSnippet: this.querySelector('.review-snippets')
            }
            this.extractLatestReviews();
        }
        decodeHtml(str) {
            const txt = document.createElement('textarea');
            let decoded = str;
            let prev;
            do {
                prev = decoded;
                txt.innerHTML = prev;
                decoded = txt.value;
            } while (decoded !== prev);
            return decoded.replace(/"/g, '');
        }
        async extractLatestReviews(dt) {
            const options = {method: 'GET', headers: {accept: 'application/json'}};

            await fetch('https://api.reviews.io/merchant/reviews?store=themagic5-com&min_rating=5&order=desc', options)
            .then(res => res.json())
            .then(res => {
                let reviewLimit = 0;
                for(const review of res.reviews) {
                    if(reviewLimit > 2) break;
                    const reviewItem = document.createElement('article');
                    const reviewScoreStars = document.createElement('div');
                    reviewScoreStars.classList.add('review-score-stars');
                    const reviewScore = document.createElement('div');
                    reviewScore.classList.add('rating');
                    reviewScore.innerText = review?.rating;
                    reviewScoreStars.append(reviewScore);
                    const reviewStars =document.createElement('div');
                    for (let i = 1; i <= 5; i++) {
                        if(i <= parseInt(review?.rating)) {
                            reviewStars.innerHTML += `
                                <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z" fill="#FFBC35"/>
                                </svg>
                            `;
                        } else {
                            reviewStars.innerHTML += `
                               <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z" fill="url(#paint0_radial_3592_1384)"/>
                                    <defs>
                                    <radialGradient id="paint0_radial_3592_1384" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11 11) rotate(59.063) scale(10.8515)">
                                    <stop stop-color="#FFBC35" stop-opacity="0.25"/>
                                    <stop offset="1" stop-color="#FF990B" stop-opacity="0.25"/>
                                    </radialGradient>
                                    </defs>
                               </svg>
                            `;
                        }                        
                    }
                    const reviewCustomer = document.createElement('div');
                    reviewCustomer.classList.add('review-customer');
                    const firstName = this.decodeHtml(review?.reviewer?.first_name || '');
                    const lastName = this.decodeHtml(review?.reviewer?.last_name || '');
                    reviewCustomer.innerText = `${firstName} ${lastName}, ${review?.timeago}, ${review?.date_formatted}`;
                    reviewStars.classList.add('review-stars');
                    reviewScoreStars.append(reviewStars);
                    const reviewComments = document.createElement('div');
                    const fullText = review?.comments;
                    if(fullText.length > this.maxChars) {
                        const shortText = fullText.substring(0, this.maxChars) + "...";
                        reviewComments.classList.add('comments');
                        reviewComments.classList.add('read-more');
                        reviewComments.innerHTML = `<span>${shortText}</span>`;
                        const readMore = document.createElement('button');
                        readMore.classList.add('read-more');
                        readMore.textContent = "Read more";
                        readMore.addEventListener('click', () => {
                            reviewComments.classList.remove('read-more');
                            reviewComments.classList.add('read-less');
                            reviewComments.querySelector('span').innerText = fullText;
                        })
                        const readLess = document.createElement('button');
                        readLess.classList.add('read-less');
                        readLess.textContent = "Read less";
                        readLess.addEventListener('click', () => {
                            reviewComments.classList.add('read-more');
                            reviewComments.classList.remove('read-less');
                            reviewComments.querySelector('span').innerText = shortText;
                        })
                        reviewComments.append(readMore);
                        reviewComments.append(readLess);
                    } else {
                        reviewComments.classList.add('comments');
                        reviewComments.innerHTML = fullText;
                    }         
                    reviewItem.append(reviewScoreStars);
                    reviewItem.append(reviewComments);
                    reviewItem.append(reviewCustomer);
                    this.selectors.reviewsSnippet.append(reviewItem);
                    reviewLimit++;
                }
            });
        }
    }
    customElements.define('store-reviews', StoreReviews);
}